/* unplugin-vue-components disabled */
import BuilderInputs from 'components/builder/builder-inputs.vue'
import {makeGuardrailsSchema} from 'pages/settings/settings-defs'
import $global from 'stores/global'

export default {
  components: {
    BuilderInputs
  },
  provide() {
    return {
      store: this.system,
    }
  },
  data() {
    return {
      system: {...$global.caps},
      schema: makeGuardrailsSchema(),
      saved_at: undefined,
      saving: false,
      update: $utils.timers.debounce(this.onUpdate, 800),
    }
  },
  beforeUnmount() {
    this.update.abort()
  },
  methods: {
    async onUpdate() {
      this.saving = true
      try {
        // TODO: put_settings
        await $global.setSuCaps(this.system)
        this.saved_at = Date.now()
      } 
      catch (err) {
        $utils.toasts.error(err)
      }
      this.saving = false
    },
  },
}
